import { t } from '@ankr.com/common';

import { EMilliSeconds, ESeconds } from 'modules/common/constants/const';
import { IS_PROD } from 'modules/common/constants/env';

export const EMAIL_QUERY_PARAM_NAME = 'email';
// hashed replacement for EMAIL_QUERY_PARAM_NAME (BE-1); read alongside the
// legacy `email` param during the dual-accept rollout
export const EMAIL_HASH_QUERY_PARAM_NAME = 'email_hash';
export const TELEGRAM_CONFIRMATION_DATA_PARAM_NAME = 'confirmation_data';
export const SLACK_CODE_PARAM_NAME = 'code';
export const EMAIL_CONFIRMATION_DATA_PARAM_NAME = 'confirmation_data';

export const SET_UP_2FA_CACHE_KEY = 'init-2fa';

export const getEmailFallback = () =>
  t('user-settings.common.email-value-fallback');

export const CHANGE_EMAIL_REQUEST_INTERVAL = IS_PROD
  ? 15 * ESeconds.Minute
  : 5 * ESeconds.Minute;

export const CLEAR_EMAIL_PENDING_STATE_INTERVAL = IS_PROD
  ? EMilliSeconds.Hour
  : 10 * EMilliSeconds.Minute;

export const SHOULD_SHOW_TELEGRAM_ALL_TEAMMATES_FLAG = false;

// in lower case for uniformity
export const MOBILE_OPERATION_SYSTEMS = ['android', 'ios'];
